/*
 * @Description: 系统配置相关API接口
 */
import request from '@/utils/request'

/**
 * @description 批量获取系统配置(app端使用)
 * @param {Array} configKeys 配置项键名数组
 * @returns {Promise} 返回配置项键值对映射
 */
export function getConfigs(configKeys) {
  return request({
    url: '/app/user/getConfigs',
    method: 'post',
    data: configKeys
  })
}